import React from "react";

import * as S from "../Text.styles";

import { Row, Col, SpacerBase } from "../../../atoms/GridSystem";
import { Heading, Paragraph } from "../../../atoms/Typography/Typography.component";
import Button from "../../../atoms/Button/Button.component";

import Image from "next/image";

const TextWithImage = ({ title, paragraph, cta, imageShape, image, textAlign = 'left' }) => {
  return (
    <Row $reverse={textAlign === 'right'}>
      <Col 
        xs={12} 
        lg={6} 
        $offset={{ xs: 0, lg: 1 }} 
        $offsetRight={{ xs: 0, lg: 1 }} 
        $justify="center" 
        $align="center" 
        $direction="column"
      >
        <Heading {...title} />
        <SpacerBase xs={4} lg={2} />
        {paragraph ? (
          <>
            <Paragraph typo={'paragraphLG'} content={paragraph} textAlign="center"/>
            <SpacerBase xs={3} lg={2} />
          </>
        ) : null}
        {cta ? <Button {...cta} /> : null}
      </Col>
      <Col xs={12} lg={4}>
        <S.TextWithImageMask maskType={imageShape}>
          <Image
            src={image.url}
            alt={image.alternativeText}
            fill
          />
        </S.TextWithImageMask>
      </Col>
    </Row>
  )
}

export default TextWithImage